import React from 'react'
import Grid from '@material-ui/core/Grid'
import { useStyle } from './Style'
import { formatDateLocale } from '../../../../../lib/utils.es6'

const ClaimNotes = props => {
  const classes = useStyle()
  const notes = props.claim.claim_notes || []

  const sortedNotes = notes.slice().sort(function(a, b) {
    return new Date(b.created_at) - new Date(a.created_at)
  })

  if (sortedNotes.length === 0) {
    return (
      <Grid container spacing={2} className={classes.noteswrapper}>
        <Grid item xs={12} md={12} sm={12}>
          <div className={classes.notesbox}>
            <p>No notes have been added to this claim yet.</p>
          </div>
        </Grid>
      </Grid>
    )
  }

  return (
    <Grid container spacing={2} className={classes.noteswrapper}>
      {sortedNotes.map(function(note, index) {
        return (
          <Grid item xs={12} md={6} sm={6} key={note.guid || index}>
            <div className={classes.notesbox}>
              <h4>{note.description}</h4>
              <p>{note.text}</p>
              <h4>Added by: {note.created_by || 'N/A'}</h4>
              <p>{formatDateLocale(note.created_at)}</p>
            </div>
          </Grid>
        )
      })}
    </Grid>
  )
}

export default ClaimNotes
